import { FormOfferProvider } from './../../../../context/FormOfferContext';
import CreateOffer from './CreateOffer';

function AddOffer() {
  return (
    <FormOfferProvider>
      <CreateOffer />
    </FormOfferProvider>
  );
}

export default AddOffer;